export const Bio = {
  name: "Avinash M",
  roles: [
    "Full Stack Developer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/tech-and-avinash",
  // whatsapp2: "https://wa.me/message/IZHJV3QSWGUAG1",
  whatsapp: "https://chat.whatsapp.com/CkcP5JasThuHjkjxB1otcf",
  session: 'https://topmate.io/tech_and_avinash?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready',
  resume:
    "https://drive.google.com/file/d/1twh52JFAqy6kdrfmF1ehtt5GprBLulKs/view",
  linkedin: "https://www.linkedin.com/in/avinash-m-628635a5/",
  twitter: "https://twitter.com/RishavChanda",
  insta: "https://www.instagram.com/tech_and_avinash/",
  facebook: "https://www.facebook.com/rishav.chanda.165/",
  youtube: "https://www.youtube.com/channel/UCqvd_6_q03VMMp73a4J2o9w/",
};

export const Bio2 = {
  name: "Learn Full Stack Web Development",
  roles: [
    "Front-End",
    "Back-End",
    "Database Management",
    "Code insight, our style!"

  ],
  description:
    "Whether you're just starting out or already have some experience, we offer various Full Stack Web Development courses designed to fit your needs.",
  github: "https://github.com/tech-and-avinash",
  // whatsapp2: "https://wa.me/message/IZHJV3QSWGUAG1",
  whatsapp: "https://chat.whatsapp.com/CkcP5JasThuHjkjxB1otcf",
  resume:
    "https://drive.google.com/file/d/1twh52JFAqy6kdrfmF1ehtt5GprBLulKs/view",
  linkedin: "https://www.linkedin.com/in/avinash-m-628635a5/",
  twitter: "https://twitter.com/RishavChanda",
  insta: "https://www.instagram.com/tech_and_avinash/",
  facebook: "https://www.facebook.com/rishav.chanda.165/",
  youtube: "https://www.youtube.com/channel/UCqvd_6_q03VMMp73a4J2o9w/",
};

export const Bio3 = {
  name: "Learn Full Stack Web Development",
  roles: [
    "Instagram",
    "Youtube",
    "LinkedIn",
    

  ]};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "image/react.png",
      },
      {
        name: "Angular.js",
        image:
          "image/Angular.js.png",
      },
      {
        name: "next.js",
        image:
          "image/next.js.png",
      },
      {
        name: "Redux",
        image:
          "image/redux.png ",
      },
      {
        name: "Flutter",
        image:
          "image/flutter.png",
      },
        
      {
        name: "Vue js ",
        image:
          "image/vuejs.png"
      },
      {
        name: "HTML",
        image: "image/html.png",
      },
      {
        name: "CSS",
        image:
          "image/css.png",
      },
   
      {
        name: "Bootstrap",
        image:
          "image/bootstrap.png",
      },
      {
        name: "Material UI",
        image:
          "image/material-ui.png",
      },

      {
        name: "Tailwind CSS",
        image:
          "image/tailwindcss.png"
      },
    ],
  },
  {
    title: "programming language",
    skills: [
      {
        name: "javascript",
        image: "image/javascript.png",
      },
      {
        name: "TypeScript",
        image:
          "image/TypeScript.png",
      },
      {
        name: "Python",
        image:
          "image/Python.png",
      },
      {
        name: "Golang",
        image: "image/Golang.png",
      },
    ],
  },
  {
    title: "Back-End",
    skills: [
      {
        name: "Node.js",
        image:
          "image/Node.js.png",
      },
      {
        name: "Nest.js",
        image:
          "image/Nest.js.png",
      },
      {
        name: "Express.js",
        image: "image/Express.png",
      },
      {
        name: "Koa.js",
        image:
          "image/Koa.js.png",
      },
      {
        name: "gorilla mux ",
        image:
          "image/gorilla mux Golang.png",
      },
      {
        name: "Gin ",
        image:
          "image/Gin.png",
      },
 
   
      {
        name: "flask",
        image:
          "image/flask.png",
      },
    ],
  },
  {
    title: "Scripting and Operating Systems",
    skills: [
      {
        name: "Shell Scripting",
        image: "image/Shell-Scripting.png",
      },
      {
        name: "Linux",
        image:
          "image/Linux.png",
      },
      {
        name: "MacOS",
        image:
          "image/MacOS.png",
      },
      {
        name: "Windows",
        image: "image/Windows.png",
      },
    ],
  },

  {
    title: "Containerization and Orchestration",
    skills: [
      {
        name: "Docker",
        image: "image/Docker.png",
      },
      {
        name: "Kubernetes",
        image:
          "image/Kubernetes.png",
      },
    ],
  },

  {
    title: "Cloud Services",
    skills: [
      {
        name: "AWS (Amazon Web Services)",
        image: "image/AWS.png",
      },
      {
        name: "Azure (Microsoft Azure)",
        image:
          "image/Azure.png",
      },
      {
        name: "GCP (Google Cloud Platform)",
        image:
          "image/GCP.png",
      },
    ],
  },

  {
    title: "Database",
    skills: [

      {
        name: "mongodb-compass",
        image:
          "image/mongodb-compass.png",
      },
      {
        name: "MySQL",
        image:
          "image/MySQL.png",
      },
      {
        name: "postgresql",
        image:
          "image/postgresql.png",
      },
      {
        name: "pgAdmin",
        image:
          "image/postgresql.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "image/Git.png",
      },
      {
        name: "GitHub",
        image:
          "image/GitHub.png",
      },
      {
        name: "GitLab",
        image: "image/GitLab.png"
      },
      {
        name: "VS Code",
        image:
          "image/Visual-Studio-Code.png",
      },
      {
        name: "Postman",
        image:
          "image/Postman.png",
      },
      {
        name: "Netlify",
        image:
          "image/Netlify.png",
      },

      {
        name: "Figma",
        image:
          "image/Figma.png",
      },
  

      {
        name: "Adobe XD",
        image:
          "image/Adobe-XD.png",
      },
      {
        name: "Jira",
        image: "image/Jira.png",
      },
      {
        name: "Google Slides",
        image: "image/Google-Slides.png",
      },
      {
        name: "Google Docs",
        image: "image/Google-Docs.png",
      },
 
      {
        name: "google sheet",
        image:
          "image/google-sheet.png",
      },
      {
        name: "Microsoft Teams",
        image: "image/Microsoft-Teams.png",
      },

      {
        name: "Skype",
        image: "image/Skype.png",
      },
      {
        name: "Discord",
        image: "image/Discord.png",
      },

      {
        name: "slack",
        image: "image/slack.png",
      },
      {
        name: "Bitbucket",
        image: "image/Bitbucket.png",
      },

    ],
  },
];

export const skills2 = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "image/react.png",
      },
      {
        name: "Angular.js",
        image:
          "image/Angular.js.png",
      },
      {
        name: "next.js",
        image:
          "image/next.js.png",
      },
      {
        name: "Redux",
        image:
          "image/redux.png ",
      },
      {
        name: "Flutter",
        image:
          "image/flutter.png",
      },
        
      {
        name: "Vue js ",
        image:
          "image/vuejs.png"
      },
      {
        name: "HTML",
        image: "image/html.png",
      },
      {
        name: "CSS",
        image:
          "image/css.png",
      },
   
      {
        name: "Bootstrap",
        image:
          "image/bootstrap.png",
      },
      {
        name: "Material UI",
        image:
          "image/material-ui.png",
      },

      {
        name: "Tailwind CSS",
        image:
          "image/tailwindcss.png"
      },
    ],
  },
]

export const experiences = [
  {
    id: 0,
    img: "image/PantryClub.png", 
    role: "Full Stack Developer",
    company: "PantryClub (Pty) Ltd",
    date: "Dec 2025 - May 2026",
    desc: "Engineered and maintained WhatsApp webhook integrations with embedded support chat systems, reducing response handling time by 50%. Spearheaded scalable support ticket management systems with automated routing, improving overall workflow resolution metrics by 35%. Automated structured billing procedures by deploying AI-powered invoice generation modules, slashing manual operations by 70%. Executed data validation workflows for Purchase Order (PO) processing systems, boosting transaction billing accuracy to 99.4%. Orchestrated backend services for workflow automation, integrating AI-assisted operational steps to increase production throughput by 25%. Authored high-performance Next.js frontend modules for client-facing support dashboards, boosting active user engagement metrics by 40%. Enforced role-based access control and strict webhook validation mechanisms, ensuring 100% data compliance and system reliability. Containerized microservices using Docker and automated deployments via CI/CD, reducing system update downtime by 45%. Integrated structured logging mechanisms across AI workflows, reducing production debugging and troubleshooting times by 30%. Partnered directly with cross-functional clients to tailor enterprise-grade solutions, expanding product feature adoption by 20%.",
    skills: [
      "Go (Golang)",
      "gRPC",
      "Next.js",
      "AI Workflows",
      "Docker",
      "CI/CD",
      "Automation"
    ]
  },
  {
    id: 1,
    img: "image/Marsdev.png",
    role: "Senior Software Engineer",
    company: "Marsdev",
    date: "Aug 2023 - Aug 2025",
    desc: "Spearheaded development of AFTO, an AI-powered pipeline using llamaindex orchestration, accelerating document extraction times by 60%. Architected reusable Terraform modules for Azure networking and compute stacks, eliminating manual provisioning errors by 90%. Scaled application deployments using Kubernetes orchestration and Docker, maintaining a resilient 99.95% environment uptime. Designed high-concurrency REST and gRPC backend APIs, maximizing network throughput and reducing endpoint latency by 35%.",
    skills: [
      "Node.js",
      "FastAPI",
      "LlamaIndex",
      "Terraform",
      "Azure",
      "Kubernetes",
      "Docker",
      "gRPC"
    ]
  },
  {
    id: 2,
    img: "image/Mediwave-Digital.png",
    role: "Senior Full Stack Developer",
    company: "Mediwave Digital",
    date: "Apr 2022 - Jul 2023",
    desc: "Architected microservices for healthcare platforms using Node.js, Koa, and Python, scaling to 15K+ users with 99.9% reliability. Formulated FHIR data-exchange implementations, securing 100% compliance with critical healthcare interoperability guidelines. Optimized SQL database performance and structured indices across PostgreSQL and MySQL, yielding a 30% reduction in query execution times. Deployed Elasticsearch-backed semantic retrieval workflows, increasing domain-specific document discovery speeds by 40%. Streamlined continuous integration pipelines and cloud alerting tools, reducing production incident response times by 25%.",
    skills: [
      "Node.js",
      "React.js",
      "Koa.js",
      "FHIR",
      "PostgreSQL",
      "MySQL",
      "Elasticsearch",
      "CI/CD"
    ]
  },
  {
    id: 3,
    img: "image/AIML-Datalogics.png", 
    role: "Lead Full Stack Developer",
    company: "AIML Datalogics",
    date: "Dec 2018 - Apr 2022",
    desc: "Engineered a rapid application development (RAD) platform, boosting multi-cloud deployment automation speeds by 50% for enterprise clients. Created Go-based CLI and web utilities for multi-cloud environment operations, lowering manual infrastructure setup times by 45%. Designed performant GraphQL APIs and services in Golang, Python, and Node.js, improving data delivery metrics by 35%. Constructed gRPC microservices in Go, minimizing distributed system inter-service communication latency by 40%. Directed Python-based NLP text processing pipelines with advanced OCR tooling, achieving a 98% accuracy rate on document tokenization. Supervised container orchestrations across distributed staging nodes, securing stable multi-cloud availability for production clusters. Eliminated redundant engineer tasks by deploying automated Python and Go CLI workflow scripts, elevating team productivity by 20%.",
    skills: [
      "Node.js",
      "Python",
      "Flask",
      "FastAPI",
      "Golang",
      "GraphQL",
      "gRPC",
      "Kubernetes",
      "Multi-Cloud"
    ]
  }
];

export const purposes = [
  {
    id: 0,
    desc: [
      'Discover Your True Potential',
      'Unique Approach for Soft Skills',
      'Self Realization',
      'Awareness on Misleads',
      'Showcase Our Potential for Your Understanding',
      'Create a Like-Minded Environment of People',
      'Gain Insight into Our Carefully Designed Course',
    ],
  },
];
// export const socials = [
//   {
//     id: 0,
//     desc: [
//      'e-mail, social media'

//     ],
//   },
// ];
export const time = [
  {
    id: 0,
    desc: [
      'Participate in our free webinar',
      'The webinar focuses on full-stack development',
      '2-Hour Live webinar',
      'Click to join WhatsApp group and fill the form below if interested',
      'Meet link will be updated in WhatsApp group',
      'Master Full-Stack: Unleash Your Web Skills!',
      'Elevate Your Code: Full-Stack Mastery Unleashed'
    ],
  },
];
export const Forwhoms = [
  {
    id: 0,
    desc: [
     `EXCLUSIVE "LIVE" FULL-STACK DEVELOPMENT WEBINAR

       Unlock the Secrets to The knowledge about Digital Solutions

       Why pay upfront? Invest after the event, ensuring satisfaction and value.

       Immerse yourself in the dynamic realm of full-stack development, uncovering powerful methods to craft resilient digital solutions. 
      
       This is your chance to elevate your skills and revolutionize your approach, ensuring a unique and invaluable experience.

       Ready to embark on an enriching course? Seize the opportunity to explore limitless possibilities in the world of full-stack development with us.

       Claim your spot now for an impactful experience!`
    ],
  },
];
export const iconListData = [
  'Innovate & Excel',
  'Tech Mastery Hub',
  'StackSkills Unleashed',
  'Practical Dev Boost',
  'Future-Ready Coding',
  'Interactive Code Hub', 
];


export const education = [
  {
    id: 0,
    img: "image/embedded.png",
    school: "PGDESD",
    date: "2016-2017",
    grade: "8.71 CGPA",
    degree: "Post Graduate Diploma in Embedded System and Design",
  },
  {
    id: 1,
    img: "image/Achariya-College.png",
    school: " Achariya College Of Engineering Technology, Puducherry",
    date: "2013-2017",
    grade:"",
    degree: "Bachelor of Technology in Electronics and Communication Engineering",
    
  },
  {
    id: 2,
    img: "image/Vivekanandha.png",
    school: "Vivekanandha Higher Secondary School Puducherry",
    date: "2012-2013",
    grade: "70.41%",
    degree: "H.S.C, State board",
  },
  {
    id: 3,
    img: "image/Vivekanandha.png",
    school: "Vivekanandha Higher Secondary School,Puducherry",
    date: " 2010-2011",
    grade: "84.8%",
    degree: "S.S.L.C, State Board",
  },
];




export const projects = [
  {
    id: 9,
    title: "Openworx",
    // date: "Jun 2023 - Jul 2023",
    description:
      "An employee dashboard is a data visualization tool that lets HR professionals view, track and analyze various key performance indicators in both the short and long term. Employee dashboards should be interactive  modern  and showcase human resources analytics and statistics this is the description",
    image:
      "image/projects image/openworx.png",
    // tags: [
    //   "Docker",
    //   "AWS",
    //   "DuckDNS",
    //   "Eslint",
    //   "Husky",
    //   "CI/CD",
    //   "React Js",
    //   "MongoDb",
    //   "Node Js",
    //   "Express Js",
    //   "Redux",
    // ],
    category: "SPL",
    github: "https://github.com/rishavchanda/Trackify",
    webapp: "https://trackify.duckdns.org",
  },
  {
    id: 0,
    title: "SPL",
    // date: "Apr 2023 - May 2023",
    description:
      "  SPL applications, are software designed for the education industry. By utilizing technology, they can enhance the quality of teaching and learning. These innovative tools have become popular. They cater to the diverse needs of students, educators, and educational institutions.",
    image:
      "image/projects image/SPL.png",
    // tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Podstream",
    // webapp: "https://podstream.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 1,
    title: "BOOMFIRE",
    // date: "Oct 2022 - Present",
    description:
      "What do they look for in a home fire inspection? A home fire inspection — or a fire safety inspection — ensures that the proper precautions are in place to avoid house fires. The inspector will look for smoke alarms and fire extinguishers, potential fire hazards and physical obstructions.",
    image:
      "image/projects image/boomfire.png",
    // tags: [
    //   "React Js",
    //   "MongoDb",
    //   "Node Js",
    //   "Express Js",
    //   "Redux",
    //   "NodeMailer",
    // ],
    category: "web app",
    // github: "https://github.com/rishavchanda/Project-Management-App",
    // webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 2,
    title: "MAP",
    // date: "Jan 2023 - Mar 2023",
    description:
      "A workshop that creates a map of the customer's journey gives us the opportunity to find these moments - the moments that really matter in creating a positive customer experience. ‍ A good journey map can also be an invaluable template for teams to collect assumptions, data or research and share findings on one page.",
    image:
      "image/projects image/map.png",
    // tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    // github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
    // webapp: "https://brain-tumor.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 3,
    title: "Superbloom",
    // date: "Dec 2021 - Apr 2022",
    description:
      "Video conferencing is live, visual connection between two or more remote parties over the internet that simulates a face-to-face meeting. Video conferencing is important because it joins people who would not normally be able to form a face-to-face connection.",
    image:
      "image/projects image/Superbloom.png",
    // tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
    category: "android app",
    // github: "https://github.com/rishavchanda/Buckoid-Android-App",
    // webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  },
  {
    id: 10,
    title: "Smartbuilding",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Smart buildings, which connect building operations through the Internet of Things (IoT), simplify tasks like controlling building temperature, security and maintenance through mobile devices and computers.",
    image:
      "image/projects image/smart-building.jpg",
    // tags: ["React Native", "JavaScript", "Axios"],
    category: "android app",
    // github: "https://github.com/rishavchanda/Job-finder-App",
    // webapp: "https://github.com/rishavchanda/Job-finder-App",
  },
  {
    id: 4,
    title: "Terrapay",
    // date: "Jul 2021",
    description:
      "TerraPay is a global mobile-first payments service that allows anyone, anywhere, to send and receive money to a wallet or bank account instantly.",
    image:
      "image/projects image/terrapay.png",
    // tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
    // webapp: "https://whatsapp-clone-rishav.web.app",
  },
  {
    id: 5,
    title: "Gonife",
    // date: "Jun 2021",
    description:
      " Though often mistaken for a specific model, rapid application development (RAD) is the idea that we benefit by treating our software projects like clay rather than steel, in the sense that they can be tested and refined, instead of following detailed planning and design phases that are typically associated with traditional development models.      ",
    image:
      "image/projects image/Gonife.png",
  //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Todo-Web-App",
  //   webapp: "https://rishav-react-todo.netlify.app/",
  },
  {
    id: 6,
    title: "Perinatal Access",
    // date: "Jun 2021",
    description:
      "Video conferencing is a live video-based meeting between two or more people in different locations using video-enabled devices. Video conferencing allows multiple people to meet and collaborate face to face long distance by transmitting audio, video, text and presentations in real time through the internet.",
    image:
      "image/projects image/PerinatalAccess.png",
    // tags: ["React Js", "API", "Axios", "Node JS"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Breaking-Bad",
    // webapp: "https://breaking-bad-webapp.netlify.app",
  },
  {
    id: 7,
    title: "MAIA",
    // date: "Dec 2020 - Jan 2021",
    description:
      "A health tracker is an electronic application used to record and manage healthy living statistics and measure progress, but what does it really mean? A health tracker is a way to take all your data and put it together to form a meaningful picture of your overall lifestyle, be it healthy or not so",
    image:
      "image/projects image/maia.png",
    // tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
    category: "android app",
  //   github: "https://github.com/rishavchanda/Quiz-Earn",
  //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
  },
  {
    id: 8,
    title: "MSI",
    // date: "Jan 2021",
    description:
      "Questionnaire surveys are a technique for gathering statistical information about the attributes, attitudes, or actions of a population by a structured set of questions.",
    image:
      "image/projects image/msi.png",
    // tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    // github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    // webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  },
  {
    id: 0,
    title: "Worcestershire",
    // date: "Apr 2023 - May 2023",
    description:
      "A health tracker is an electronic application used to record and manage healthy living statistics and measure progress, but what does it really mean? A health tracker is a way to take all your data and put it together to form a meaningful picture of your overall lifestyle, be it healthy or not so",
    image:
      "image/projects image/Worcestershire.png",
    // tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Podstream",
    // webapp: "https://podstream.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 0,
    title: "Oxcare",
    // date: "Apr 2023 - May 2023",
    description:
      "Health services serve patients, families, communities, and populations. They cover emergency, preventative, rehabilitative, long-term, hospital, diagnostic, primary, palliative, and home care. These services are centered around making health care accessible, high quality, and patient-centered",
    image:
      "image/projects image/oxcare.png",
    // tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Podstream",
    // webapp: "https://podstream.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 0,
    title: "Southern",
    // date: "Apr 2023 - May 2023",
    description:
      "SHS's mission is to make healthcare available to the community, by constantly developing new ways to reach the community and those needing medical treatment, supplies and technologies. Our goal is simple: to provide you with the most innovative equipment so that you can live a healthier, longer and carefree life.",
    image:
      "image/projects image/south.jpg",
    // tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Podstream",
    // webapp: "https://podstream.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 0,
    title: "Camino",
    // date: "Apr 2023 - May 2023",
    description:
      "Create a trip itinerary, organize flight, hotel, and car reservations, view places to visit on a map, and collaborate with friends. After your trip, share a travel guide to inspire other travelers. Every time you add a place to visit, it's immediately pinned on your Google Maps-based travel map.",
    image:
      "image/projects image/camino.png",
    // tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Podstream",
    // webapp: "https://podstream.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 0,
    title: "Broadcom",
    // date: "Apr 2023 - May 2023",
    description:
    "Broadcom - Catalog is an innovative web application designed for efficient catalog management. It utilizes OCR technology for scanning, digital catalog creation, organization, and contact integration.",
    image:
      "image/projects image/broadcom.png",
    // tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Podstream",
    // webapp: "https://podstream.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 0,
    title: "Diabetes moments",
    // date: "Apr 2023 - May 2023",
    description:
      "All in all, social media is a great tool for older people to stay in touch with friends and family in our modern world. While you may have some privacy concerns, it is easy to protect yourself and enjoy the many benefits of the online world. The internet can be a great source of information and inspiration too",
    image:
      "image/projects image/diabetes.png",
    // tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Podstream",
    // webapp: "https://podstream.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 0,
    title: "Growdash",
    // date: "Apr 2023 - May 2023",
    description:
      "Growdash is a business intelligence and analytics tool built specifically for restaurants to support profitable growth strategic decisions across online sales channels",
    image:
      "image/projects image/Growdash.png",
    // tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Podstream",
    // webapp: "https://podstream.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
